import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { Constant } from '../constant/constant';

@Injectable({
  providedIn: 'root'
})
export class MasterService {
  httpOptions = {
    headers: new HttpHeaders({
      'content-type': 'application/json'
    })
  };
  httpOptions2 = {
    headers: new HttpHeaders({
      'content-type': 'application/json'
    })
  }
  
httpOptions_2 = {
    headers: new HttpHeaders({
      'content-type': 'application/json',
      'Authorization': '**********',
      'location': '13.202.251.155'
    })
  };

  constructor(private http: HttpClient) { }
 
  
  //ofiice expense
  insert_o_office_expense(userItem){
    return this.http.post(Constant.CONSTANT_API_local + 'insert_o_office_expense', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
  }

  get_o_office_expense(office_expense_id) {
    return this.http.get(Constant.CONSTANT_API_local + 'get_o_office_expense?office_expense_id='+office_expense_id,this.httpOptions).pipe(retry(2))
  }
  update_o_office_expense(item): Observable<any> {
    return this.http.put(Constant.CONSTANT_API_local + 'update_o_office_expense', JSON.stringify(item), this.httpOptions).pipe(retry(2))
  }
  //penalty
  insert_o_penalty_advance(userItem): Observable<any> {
    return this.http.post(Constant.CONSTANT_API_local + 'insert_o_penalty_advance', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
  }
  
  get_o_penalty_advance(penalty_advance_id) {
    return this.http.get(Constant.CONSTANT_API_local +'get_o_penalty_advance?penalty_advance_id=' + penalty_advance_id)
  }
  update_o_penalty_advance(item): Observable<any> {
    return this.http.put(Constant.CONSTANT_API_local + 'update_o_penalty_advance', JSON.stringify(item), this.httpOptions).pipe(retry(2))
  }
  //house expense
  insert_o_house_expense(userItem): Observable<any> {
    return this.http.post(Constant.CONSTANT_API_local + 'insert_o_house_expense', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
  }
  
  get_o_house_expense(hr_expense_id) {
    return this.http.get(Constant.CONSTANT_API_local +'get_o_house_expense?hr_expense_id=' + hr_expense_id)
  }
  update_o_house_expense(item): Observable<any> {
    return this.http.put(Constant.CONSTANT_API_local + 'update_o_house_expense', JSON.stringify(item), this.httpOptions).pipe(retry(2))
  }
  //outstanding
  insert_o_outstanding_amt(userItem): Observable<any> {
    return this.http.post(Constant.CONSTANT_API_local + 'insert_o_outstanding_amt', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
  }
  
  get_o_outstanding_amt(id) {
    return this.http.get(Constant.CONSTANT_API_local +'get_o_outstanding_amt?id=' + id)
  }
  update_o_outstanding_amt(item): Observable<any> {
    return this.http.put(Constant.CONSTANT_API_local + 'update_o_outstanding_amt', JSON.stringify(item), this.httpOptions).pipe(retry(2))
  }

  //unplanned
  insert_o_unplaned_expense(userItem): Observable<any> {
    return this.http.post(Constant.CONSTANT_API_local + 'insert_o_unplaned_expense', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
  }
  
  get_o_unplaned_expense(expense_id) {
    return this.http.get(Constant.CONSTANT_API_local +'get_o_unplaned_expense?expense_id=' + expense_id)
  }
  update_o_unplaned_expense(item): Observable<any> {
    return this.http.put(Constant.CONSTANT_API_local + 'update_o_unplaned_expense', JSON.stringify(item), this.httpOptions).pipe(retry(2))
  }

  delete_o_house_expense(hr_expense_id) {
    return this.http.delete(Constant.CONSTANT_API_local + 'delete_o_house_expense/' + hr_expense_id)
  }
  delete_o_office_expense(office_expense_id) {
    return this.http.delete(Constant.CONSTANT_API_local + 'delete_o_office_expense/' + office_expense_id)
  }
  delete_o_outstanding_amt(id) {
    return this.http.delete(Constant.CONSTANT_API_local + 'delete_o_outstanding_amt/' + id)
  }
  delete_o_unplaned_expense(expense_id) {
    return this.http.delete(Constant.CONSTANT_API_local + 'delete_o_unplaned_expense/' + expense_id)
  }
  delete_o_penalty_advance(penalty_advance_id) {
    return this.http.delete(Constant.CONSTANT_API_local + 'delete_o_penalty_advance/' + penalty_advance_id)
  }


SERVER_URL: string = "http://45.118.160.218/universal_transport"; 

 
public uploadFile(data) { 
  // let uploadURL ='${this.SERVER_URL}/upload_documents.php;'  
  let uploadURL =this.SERVER_URL+'/upload_documents.php' 
  console.log('121',uploadURL, data) 
  return this.http.post<any>(uploadURL, data); 
}

//trip
insert_o_trip_sheet(userItem): Observable<any> {
  return this.http.post(Constant.CONSTANT_API_local + 'insert_o_trip_sheet', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
}

get_o_trip_sheet(trip_id) {
  return this.http.get(Constant.CONSTANT_API_local +'get_o_trip_sheet?trip_id=' + trip_id)
}
update_o_trip_sheet(item): Observable<any> {
  return this.http.put(Constant.CONSTANT_API_local + 'update_o_trip_sheet', JSON.stringify(item), this.httpOptions).pipe(retry(2))
}

insert_o_trip_route(userItem): Observable<any> {
  return this.http.post(Constant.CONSTANT_API_local + 'insert_o_trip_route', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
}

get_o_trip_route(trip_id) {
  return this.http.get(Constant.CONSTANT_API_local +'get_o_trip_route?trip_id=' + trip_id)
}
update_o_trip_route(item): Observable<any> {
  return this.http.put(Constant.CONSTANT_API_local + 'update_o_trip_route', JSON.stringify(item), this.httpOptions).pipe(retry(2))
}
delete_o_trip_route(trip_route_id) {
  return this.http.delete(Constant.CONSTANT_API_local + 'delete_o_trip_route/' + trip_route_id)
}
insert_o_trip_expense(userItem): Observable<any> {
  return this.http.post(Constant.CONSTANT_API_local + 'insert_o_trip_expense', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
}

get_o_trip_expense(trip_id) {
  return this.http.get(Constant.CONSTANT_API_local +'get_o_trip_expense?trip_id=' + trip_id)
}
update_o_trip_expense(item): Observable<any> {
  return this.http.put(Constant.CONSTANT_API_local + 'update_o_trip_expense', JSON.stringify(item), this.httpOptions).pipe(retry(2))
}
delete_o_trip_expense(expense_id) {
  return this.http.delete(Constant.CONSTANT_API_local + 'delete_o_trip_expense/' + expense_id)
}
insert_m_route(userItem): Observable<any> {
  return this.http.post(Constant.CONSTANT_API_local + 'insert_m_route', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
}

get_m_route(trip_id) {
  return this.http.get(Constant.CONSTANT_API_local +'get_m_route?route_id=' + trip_id)
}
update_m_route(item): Observable<any> {
  return this.http.put(Constant.CONSTANT_API_local + 'update_m_route', JSON.stringify(item), this.httpOptions).pipe(retry(2))
}
delete_m_route(expense_id) {
  return this.http.delete(Constant.CONSTANT_API_local + 'delete_m_route?route_id=' + expense_id)
}

get_origin() {
  return this.http.get(Constant.CONSTANT_API_local +'get_origin')
}
get_destination() {
  return this.http.get(Constant.CONSTANT_API_local +'get_destination')
}
//expense master
insert_m_expense(userItem): Observable<any> {
  return this.http.post(Constant.CONSTANT_API_local + 'insert_m_expense', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
}

get_m_expense(): Observable<any> {
  return this.http.get(Constant.CONSTANT_API_local +'get_m_expense')
}
update_o_expense(item): Observable<any> {
  return this.http.put(Constant.CONSTANT_API_local + 'update_m_expense', JSON.stringify(item), this.httpOptions).pipe(retry(2))
}
delete_m_expense(expense_id) {
  return this.http.delete(Constant.CONSTANT_API_local + 'delete_m_expense/' + expense_id)
}

//driver master
Get_driver_detailsmaster(driver_id):Observable<any>{
  return this.http.get(Constant.CONSTANT_API_local + "get_m_driver_1?driver_id="+driver_id).pipe(retry(2))
}

update_driver(driverData):Observable<any>{
  return this.http.put(Constant.CONSTANT_API_local + "driver", JSON.stringify
  (driverData),this.httpOptions).pipe(retry(2))
}
getTotaldriver(flag):Observable<any>{
  return this.http.get(Constant.CONSTANT_API_local + "get_totaldriver?flag="+flag).pipe(retry(2))
}
delete(id):Observable<any>{
  return this.http.delete(Constant.CONSTANT_API_local + "driver/" +id ).pipe(retry(2))
}

//driver insert
insert(driverData):Observable<any>{
  return this.http.post(Constant.CONSTANT_API_local + "insert_driver", JSON.stringify
  (driverData),this.httpOptions).pipe(retry(2))
}


public uploadFile_diver(data) {
    let uploadURL = `${this.SERVER_URL}/upload_documents.php`;
    return this.http.post<any>(uploadURL, data);
    }

    //driver edit
    driver_detailsmaster(id):Observable<any>{
      return this.http.get(Constant.CONSTANT_API_local + "get_drivermaster?id="+id).pipe(retry(2))
    }

    //vehicle master
    getallvehiclemaster(vehicle_id):Observable<any>{
      return this.http.get(Constant.CONSTANT_API_local+ "get_m_point_vehicle?vehicle_id="+vehicle_id).pipe(retry(2))
    }
    getTotalVehicle():Observable<any>{
      return this.http.get(Constant.CONSTANT_API_local+ "get_totalvehicle").pipe(retry(2))
    }
    deletevehicle(id):Observable<any>{
      return this.http.delete(Constant.CONSTANT_API_local + 'delete_m_point_vehicle/' + id).pipe(retry(2))
    }
 
  insert_m_point_vehicle(userItem): Observable<any> {
    return this.http.post(Constant.CONSTANT_API_local + 'insert_m_point_vehicle', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
  }
  update_m_point_vehicle(item): Observable<any> {
    return this.http.put(Constant.CONSTANT_API_local + 'update_m_point_vehicle', JSON.stringify(item), this.httpOptions).pipe(retry(2))
  }

  //battery
  getBattery(vehicle_id):Observable<any>{
    return this.http.get(Constant.CONSTANT_API_local + "get_battery?vehicle_id="+vehicle_id).pipe(retry(2))
  }
  InsertBattery(data):Observable<any>{
    return this.http.post(Constant.CONSTANT_API_local+'insert_battery',JSON.stringify(data),this.httpOptions).pipe(retry(2))
  }
  UpdateBattery(data):Observable<any>{
    return this.http.put(Constant.CONSTANT_API_local  + 'update_battery' , JSON.stringify(data),this.httpOptions).pipe(retry(2))
  }
  deleteBattery(id):Observable<any>{
    return this.http.delete(Constant.CONSTANT_API_local  + 'delete_battery/' + id).pipe(retry(2))
  } 
  //check up
  insertTran(data){
    return this.http.post(Constant.CONSTANT_API_local + 'insert_vehicle_checkup',JSON.stringify(data));
    }
    getTran(id:any){
    return this.http.get(Constant.CONSTANT_API_local + 'get_vehicle_checkup?vechicle_id='+id)
    }
    DeleteTran(id){
    return this.http.delete(Constant.CONSTANT_API_local + 'delete_vehicle_checkup?checkup_id='+id)
    }
  
    UpdateTran(data:any){
    return this.http.put(Constant.CONSTANT_API_local + 'update_vehicle_checkup',JSON.stringify(data))
    }

    //tyre
    insertTyre(data):Observable<any>{
      return this.http.post(Constant.CONSTANT_API_local+"insert_tyre",JSON.stringify(data),this.httpOptions).pipe(retry(2))
    }
    GetTyre():Observable<any>{
      return this.http.get(Constant.CONSTANT_API_local+'get_tyre_type').pipe(retry(2))
    }
    Get_tyre_details(id):Observable<any>{
      return this.http.get(Constant.CONSTANT_API_local+'tyre_details?id='+id).pipe(retry(2))
    }
    delete_tyre(Vehicle_id,Tyre_type):Observable<any>{
      // return this.http.post(Constant.CONSTANT_API_local+'delete_tyre',JSON.stringify(id),this.httpOptions).pipe(retry(2))
      return this.http.delete(Constant.CONSTANT_API_local + 'delete_tyre?Vehicle_id='+Vehicle_id+'&Tyre_type='+Tyre_type)
    }
    getmodelname():Observable<any>{
        return this.http.get(Constant.CONSTANT_API_local + "get_buildtyre").pipe(retry(2))
      }

      //close trip
      get_o_route_amount(trip_id): Observable<any> {
        return this.http.get(Constant.CONSTANT_API_local +'get_o_route_amount?trip_id=' + trip_id)
      }
      update_o_route_amount(data): Observable<any> {
        return this.http.put(Constant.CONSTANT_API_local + 'update_o_route_amount', JSON.stringify(data), this.httpOptions).pipe(retry(2))
      } 
      //document upload
      UpdateVehicleDocument(data):Observable<any>{
        return this.http.put(Constant.CONSTANT_API_local+'update_vehicle_document',JSON.stringify(data),this.httpOptions).pipe(retry(2))
      }
      get_vehicle_document_download(vehicle_id):Observable<any>{
        return this.http.get(Constant.CONSTANT_API_local+'get_vehicle_document_download?vehicle_id='+vehicle_id).pipe(retry(2))
      }
      get_o_complaint(complaint_id) {
        return this.http.get(Constant.CONSTANT_API_local +'get_o_complaint?complaint_id=' + complaint_id)
      }
      delete_o_complaint(complaint_id) {
        return this.http.delete(Constant.CONSTANT_API_local +'delete_o_complaint/' + complaint_id)
      }
      insert_o_complaint(userItem): Observable<any> {
        return this.http.post(Constant.CONSTANT_API_local + 'insert_o_complaint', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
      }
      updated_o_complaint(userItem): Observable<any> {
        return this.http.put(Constant.CONSTANT_API_local + 'updated_o_complaint', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
      }
      

      get_report_based_on_vehicle_no(data) {
        return this.http.get(Constant.CONSTANT_API_local +'get_report_based_on_vehicle_no?flag=' + data.flag+'&vehicle_id='+data.vehicle_id+'&from_date='+data.from_date+'&to_date='+data.to_date+'&route_name='+data.route_name)
      }
      SP_report_get_o_profit_loss(data) {
        return this.http.get(Constant.CONSTANT_API_local +'SP_report_get_o_profit_loss?vechile_no='+data.vechile_no+'&from_date='+data.from_date+'&to_date='+data.to_date)
      }
      SP_report_get_o_mg_profit_loss(data) {
        return this.http.get(Constant.CONSTANT_API_local +'SP_report_get_o_mg_profit_loss?vechile_no='+data.vechile_no+'&from_date='+data.from_date+'&to_date='+data.to_date+'&route_name='+data.route_name)
    }
      SP_report_get_o_trip_by_date(data) {
        return this.http.get(Constant.CONSTANT_API_local +'SP_report_get_o_trip_by_date?from_date='+data.from_date+'&to_date='+data.to_date+'&trip_no='+data.trip_no)
      }
      SP_report_get_o_driver_by_date(data) {
        return this.http.get(Constant.CONSTANT_API_local +'SP_report_get_o_driver_by_date?from_date='+data.from_date+'&to_date='+data.to_date+'&driver_id='+data.driver_id+'&route_name='+data.route_name)
      }
      
      get_o_trip_no() {
        return this.http.get(Constant.CONSTANT_API_local +'get_o_trip_no')
      }

      get_m_agent(agent_id) {
        return this.http.get(Constant.CONSTANT_API_local +'get_m_agent?agent_id=' + agent_id)
      }
      delete_m_agent(agent_id) {
        return this.http.delete(Constant.CONSTANT_API_local +'delete_m_agent/' + agent_id)
      }
      insert_m_agent(userItem): Observable<any> {
        return this.http.post(Constant.CONSTANT_API_local + 'insert_m_agent', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
      }
      update_m_agent(userItem): Observable<any> {
        return this.http.put(Constant.CONSTANT_API_local + 'update_m_agent', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
      }
      
      get_o_agent_amount(agent_id) {
        return this.http.get(Constant.CONSTANT_API_local +'get_o_agent_amount?agent_amt_id=' + agent_id)
      }
      delete_o_agent_amount(agent_id) {
        return this.http.delete(Constant.CONSTANT_API_local +'delete_o_agent_amount/' + agent_id)
      }
      insert_o_agent_amount(userItem): Observable<any> {
        return this.http.post(Constant.CONSTANT_API_local + 'insert_o_agent_amount', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
      }
      update_o_agent_amount(userItem): Observable<any> {
        return this.http.put(Constant.CONSTANT_API_local + 'update_o_agent_amount', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
      }
        //Employee master
    insert_m_org_employee(userItem){
    return this.http.post(Constant.CONSTANT_API_local + 'insert_m_org_employee', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
  }

  get_m_org_employee(employee_id) {
    return this.http.get(Constant.CONSTANT_API_local + 'get_m_org_employee?employee_id='+employee_id,this.httpOptions).pipe(retry(2))
  }
  update_m_org_employee(item): Observable<any> {
    return this.http.put(Constant.CONSTANT_API_local + 'update_m_org_employee', JSON.stringify(item), this.httpOptions).pipe(retry(2))
  }
  delete_m_org_employee(id) {
    return this.http.delete(Constant.CONSTANT_API_local +'delete_m_org_employee/' + id)
  }
  get_o_trip_balance_amt() {
    return this.http.get(Constant.CONSTANT_API_local +'get_o_trip_balance_amt')
  }
  update_o_trip_amt(item): Observable<any> {
    return this.http.put(Constant.CONSTANT_API_local + 'update_o_trip_amt', JSON.stringify(item), this.httpOptions).pipe(retry(2))
  }
  SP_Report_get_based_on_over_all(data) {
    return this.http.get(Constant.CONSTANT_API_local +'SP_Report_get_based_on_over_all?from_date='+data.from_date+'&to_date='+data.to_date)
  }
  //fuel filling
  insert_o_vechile_fuel_filling(userItem): Observable<any> {
    return this.http.post(Constant.CONSTANT_API_local + 'insert_o_vechile_fuel_filling', JSON.stringify(userItem), this.httpOptions).pipe(retry(2))
  }
  get_o_vechile_fuel_filling(fuel_id) {
    return this.http.get(Constant.CONSTANT_API_local +'get_o_vechile_fuel_filling?fuel_id=' + fuel_id)
  }
  get_dashboard_vehicle_driver_counts(flag,user_type) {
    return this.http.get(Constant.CONSTANT_API_local +'get_dashboard_vehicle_driver_counts?flag='+flag+'&user_type='+user_type)
  }
  get_dashboard_vehicle_driver_documnet_verified(flag,user_type) {
    return this.http.get(Constant.CONSTANT_API_local +'get_dashboard_vehicle_driver_documnet_verified?flag='+flag+'&user_type='+user_type)
  }








  //college_details
  get_login(username, password) {
  return this.http.get(Constant.CONSTANT_API_local + 'get_login_details?username=' + username + '&password=' + password)
}

    insert_m_college_list(userItem){
    return this.http.post(Constant.CONSTANT_API_local + 'insert_m_college_list', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }
   get_m_college_list(college_id) {
    return this.http.get(Constant.CONSTANT_API_local + 'get_m_college_list?college_id='+college_id,this.httpOptions2).pipe(retry(2))
  }
   insert_m_college_details(userItem){
    return this.http.post(Constant.CONSTANT_API_local + 'insert_m_college_details', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }
   get_m_college_details(id,from_limit,to_limit) {
    return this.http.get(Constant.CONSTANT_API_local + 'get_m_college_details?id='+id+'&from_limit='+from_limit+'&to_limit='+to_limit,this.httpOptions2).pipe(retry(2))
  }
   insert_m_candidate_details(userItem){
    return this.http.post(Constant.CONSTANT_API_local + 'insert_m_candidate_intenship_details', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }
    update_m_candidate_details(userItem){
    return this.http.put(Constant.CONSTANT_API_local + 'update_m_candidate_details', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }
   get_m_candidate_details(candidate_id) {
    return this.http.get(Constant.CONSTANT_API_local + 'get_m_candidate_intenship_details?candidate_id='+candidate_id,this.httpOptions2).pipe(retry(2))
  }
    get_m_degree() {
    return this.http.get(Constant.CONSTANT_API_local + 'get_m_degree',this.httpOptions2).pipe(retry(2))
  }
   get_m_payment_mode() {
    return this.http.get(Constant.CONSTANT_API_local + 'get_m_payment_mode',this.httpOptions2).pipe(retry(2))
  }
   insert_ac_receipt_voucher(userItem){
    return this.http.post(Constant.CONSTANT_API_local + 'insert_ac_receipt_voucher', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }
    update_ac_receipt_voucher(userItem){
    return this.http.put(Constant.CONSTANT_API_local + 'update_ac_receipt_voucher', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }
   get_m_receipt_voucher(receipt_no,from_limit,to_limit) {
    return this.http.get(Constant.CONSTANT_API_local + 'get_m_receipt_voucher?receipt_no='+receipt_no+'&from_limit='+from_limit+'&to_limit='+to_limit,this.httpOptions2).pipe(retry(2))
  }
  get_m_internship_type(internship_id) {
    return this.http.get(Constant.CONSTANT_API_local + 'get_m_internship_type?internship_id='+internship_id,this.httpOptions2).pipe(retry(2))
  }
    insert_m_enrollement_detail(userItem){
    return this.http.post(Constant.CONSTANT_API_local + 'insert_m_enrollement_detail', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }
    update_m_enrollement_detail(userItem){
    return this.http.put(Constant.CONSTANT_API_local + 'update_m_enrollement_detail', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }
   get_m_enrollement_detail(enrollment_id,from_limit,to_limit) {
    return this.http.get(Constant.CONSTANT_API_local + 'get_m_enrollement_detail?enrollment_id='+enrollment_id+'&from_limit='+from_limit+'&to_limit='+to_limit).pipe(retry(2))
  }
   get_m_enrollement_detail_report(enrollment_id,mobile_no,candidate_name) {
    return this.http.get(Constant.CONSTANT_API_local + 'get_m_enrollement_detail_report?enrollment_id='+enrollment_id+'&mobile_no='+mobile_no+'&candidate_name='+candidate_name).pipe(retry(2))
  }
    get_m_candidate_details_img(candidate_id) {
    return this.http.get(Constant.CONSTANT_API_local + 'get_m_candidate_details_img?candidate_id='+candidate_id).pipe(retry(2))
  }
  get_candidate_details_fr_evaluation(enrollment_id) {
    return this.http.get(Constant.CONSTANT_API_local + 'get_candidate_details_fr_evaluation?enrollment_id='+enrollment_id).pipe(retry(2))
  }
    get_student_questions() {
    return this.http.get(Constant.CONSTANT_API_local + 'get_student_questions').pipe(retry(2))
  }
    insert_evaluation_reviewer(userItem){
    return this.http.post(Constant.CONSTANT_API_local + 'insert_evaluation_reviewer', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }
     insert_review_answers(userItem: any[]){
    return this.http.post(Constant.CONSTANT_API_local + 'insert_review_answers', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }
  get_m_receipt_voucher_report(receipt_no,enrollment_id,candidate_name) {
    return this.http.get(Constant.CONSTANT_API_local + 'get_m_receipt_voucher_report?receipt_no='+receipt_no+'&enrollment_id='+enrollment_id+'&candidate_name='+candidate_name).pipe(retry(2))
  }
   get_enrollment_pdf(userItem){
    return this.http.post('http://13.202.251.155:8080/FemtosoftMBA_Pdf/intern/report/ToPdf', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }

   mobile_validation_api(userItem){
    return this.http.post('https://sricaargo.in/college_master_api_php/index.php/mobile_validation_api', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }
  request_send_log(userItem){
    return this.http.post(Constant.CONSTANT_API_local + 'request_send_log', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }
    request_send_log_email(mail) {
    return this.http.get(Constant.CONSTANT_API_local + 'request_send_log_email?mail='+mail).pipe(retry(2))
  }
    get_candidate_pdf(userItem){
    return this.http.post('http://13.202.251.155:8080/FemtosoftMBA_Pdf/intern/report/genrate_enquiry_form', JSON.stringify(userItem), this.httpOptions2).pipe(retry(2))
  }
  
   
  get_m_branch() {
    return this.http.get(Constant.CONSTANT_API_local + 'get_m_branch',this.httpOptions2).pipe(retry(2))
  }

uploadFilee(file: File): Observable<any> {
  const formData = new FormData();
  formData.append('avatar', file); 

  return this.http.post('https://sricaargo.in/college_master_api_php/upload_documents.php', formData);
}

}
